import { RefObject, useEffect, useState } from "react";
import { ButtonV2 } from "@/ui-kit";
import styles from "./FloatingCTA.module.css";

type FloatingCTAProps = {
  title: string;
  onPress: () => void;
  heroCtaRef: RefObject<HTMLElement>;
};

export const FloatingCTA = ({ title, onPress, heroCtaRef }: FloatingCTAProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const heroCta = heroCtaRef.current;
    const footer = document.querySelector("footer");
    if (!heroCta) return;

    let heroCtaVisible = true;
    let footerVisible = false;

    const apply = () => setVisible(!heroCtaVisible && !footerVisible);

    const heroObserver = new IntersectionObserver(
      ([entry]) => {
        heroCtaVisible = entry.isIntersecting;
        apply();
      },
      { threshold: 0, rootMargin: "80px 0px 0px 0px" }
    );
    heroObserver.observe(heroCta);

    let footerObserver: IntersectionObserver | undefined;
    if (footer) {
      footerObserver = new IntersectionObserver(
        ([entry]) => {
          footerVisible = entry.isIntersecting;
          apply();
        },
        { threshold: 0 }
      );
      footerObserver.observe(footer);
    }

    return () => {
      heroObserver.disconnect();
      footerObserver?.disconnect();
    };
  }, [heroCtaRef]);

  return (
    <div
      className={styles.container}
      aria-hidden={!visible}
      data-visible={visible}
    >
      <ButtonV2 variant="primary" title={title} onPress={onPress} />
    </div>
  );
};
